var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-videoplayer-vss__wrapper"},[_c('div',{staticClass:"mc-videoplayer-vss",attrs:{"id":`videoPlayerVss-${_vm.playlistId.split(':').join('-')}`}}),(_vm.isFreeze)?[_c('div',{staticClass:"mc-trackvideo-card-vss--connecting"})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }